var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaketebgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 683,
    viewBox: "0 0 1020 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2040_26973)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2040_26973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -90,
    width: 1030,
    height: 785
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350.472 -89.3359C331.004 -58.6939 324.099 -19.3816 336.189 14.8101C348.279 49.0019 380.718 76.2981 417.091 78.4402C438.628 79.7051 459.324 84.5401 480.738 87.233C502.132 89.9259 523.874 95.0873 541.435 107.573C548.177 112.367 554.16 118.14 559.734 124.26C589.304 156.8 607.132 201.171 602.214 244.788C595.021 308.398 652.583 362.297 688.402 415.461C706.784 442.758 721.189 474.644 711.968 506.204C702.747 537.764 675.247 563.306 642.972 570.283C634.509 572.119 625.82 572.752 617.173 573.364C575.165 576.403 543.73 564.224 504.037 550.025C464.16 535.745 426.476 524.891 385.943 512.467C230.902 464.974 55.2255 540.008 -5 694.952H1024.37V-89.3359H350.472Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2040_26973)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M688.402 415.46C706.784 442.757 721.189 474.643 711.968 506.203C702.747 537.763 675.247 563.305 642.972 570.282C634.509 572.118 625.82 572.75 617.173 573.362C575.164 576.402 543.73 564.223 504.037 550.024C464.16 535.743 426.476 524.89 385.943 512.466C230.902 464.973 55.2254 540.007 -5.00003 694.951H1024.37L1020 1.5625C1020 1.5625 779.98 6.39211 705.07 112.771C636.809 209.707 584.437 261.152 688.402 415.46Z",
    fill: "url(#paint0_radial_2040_26973)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M846.26 332.852L880.215 382.242C880.42 382.609 880.686 382.976 880.973 383.323C883.391 386.118 887.633 386.444 890.461 384.037C893.268 381.63 893.596 377.407 891.178 374.592C890.891 374.245 890.564 373.959 890.236 373.694L846.281 332.872L846.26 332.852Z",
    fill: "url(#paint1_linear_2040_26973)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M851.137 338.527L880.932 381.818C881.117 382.144 881.342 382.45 881.588 382.756C883.699 385.204 887.408 385.49 889.867 383.368C892.326 381.267 892.613 377.574 890.482 375.126C890.236 374.841 889.949 374.576 889.641 374.331L851.117 338.527H851.137Z",
    fill: "url(#paint2_linear_2040_26973)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M882.551 374.898C884.703 373.062 887.961 373.287 889.805 375.449C891.65 377.591 891.424 380.835 889.252 382.671C887.08 384.507 883.842 384.283 881.998 382.12C880.133 379.978 880.379 376.734 882.551 374.898Z",
    fill: "url(#paint3_linear_2040_26973)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.754 34.053H409.099C408.525 34.0326 408.013 34.155 407.521 34.3998C407.009 34.563 406.578 34.8486 406.209 35.2362C405.8 35.6034 405.533 36.0523 405.369 36.5419C405.103 37.0315 405 37.5619 405.021 38.1127L405.164 39.194C405.369 39.8876 405.718 40.4792 406.209 40.9892L407.029 41.6217C407.664 41.9889 408.361 42.1725 409.099 42.1725H409.754C410.328 42.1929 410.841 42.0705 411.332 41.8257C411.845 41.6625 412.275 41.3769 412.644 40.9892C413.054 40.622 413.32 40.1732 413.484 39.6836C413.75 39.194 413.853 38.6636 413.832 38.1127L413.689 37.0315C413.484 36.3379 413.136 35.7462 412.644 35.2362L411.824 34.6038C411.189 34.2366 410.492 34.053 409.754 34.053Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.1 225.477C860.387 225.477 860.387 217.316 855.1 217.316C849.813 217.316 849.813 225.477 855.1 225.477Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.923 316.617C371.209 316.617 371.209 308.457 365.923 308.457C360.636 308.457 360.636 316.617 365.923 316.617Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.296 478.617C892.583 478.617 892.583 470.457 887.296 470.457C882.009 470.457 882.009 478.617 887.296 478.617Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.181 504.879C724.468 504.879 724.468 496.719 719.181 496.719C713.894 496.719 713.894 504.879 719.181 504.879Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.73 75.275C358.955 75.0506 359.181 74.8262 359.386 74.6222C359.591 74.4386 359.734 74.2142 359.816 73.9694C359.939 73.7246 360 73.4594 360 73.1738C360 72.8882 359.959 72.6229 359.816 72.3781C359.734 72.1333 359.591 71.9089 359.386 71.7253L358.976 71.3989C358.648 71.2153 358.32 71.1133 357.951 71.1133L357.398 71.1949C357.05 71.2969 356.742 71.4601 356.496 71.7253C356.271 71.9497 356.045 72.1741 355.841 72.3781C355.636 72.5617 355.492 72.7861 355.41 73.0309C355.287 73.2758 355.226 73.541 355.226 73.8266C355.226 74.1122 355.267 74.3774 355.41 74.6222C355.492 74.867 355.636 75.0914 355.841 75.275L356.25 75.6015C356.578 75.7851 356.906 75.8871 357.275 75.8871L357.828 75.8055C358.177 75.7035 358.484 75.5403 358.73 75.275Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16 169.1C306.804 169.1 306.804 165.02 304.16 165.02C301.517 165.02 301.517 169.1 304.16 169.1Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.238 565.834C510.882 565.834 510.882 561.754 508.238 561.754C505.595 561.754 505.595 565.834 508.238 565.834Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.763 419.703H317.418C317.705 419.703 317.972 419.662 318.218 419.519C318.463 419.438 318.689 419.295 318.873 419.091C319.078 418.907 319.222 418.683 319.304 418.438C319.427 418.193 319.488 417.928 319.488 417.643L319.406 417.092C319.304 416.745 319.14 416.439 318.873 416.194L318.463 415.868C318.136 415.684 317.808 415.582 317.439 415.582H316.783C316.496 415.582 316.23 415.623 315.984 415.766C315.738 415.847 315.513 415.99 315.328 416.194C315.123 416.378 314.98 416.602 314.898 416.847C314.775 417.092 314.713 417.357 314.713 417.643L314.795 418.193C314.898 418.54 315.062 418.846 315.328 419.091L315.738 419.417C316.066 419.601 316.394 419.703 316.763 419.703Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.611 491.131C272.254 491.131 272.254 487.051 269.611 487.051C266.967 487.051 266.967 491.131 269.611 491.131Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.058 540.213C371.701 540.213 371.701 536.133 369.058 536.133C366.414 536.133 366.414 540.213 369.058 540.213Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.132 610.15C844.775 610.15 844.775 606.07 842.132 606.07C839.489 606.07 839.489 610.15 842.132 610.15Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.284 275.287C881.927 275.287 881.927 271.207 879.284 271.207C876.64 271.207 876.64 275.287 879.284 275.287Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.956 28.8223C701.599 28.8223 701.599 24.7422 698.956 24.7422C696.312 24.7422 696.312 28.8223 698.956 28.8223Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.636 52.5674C531.947 52.5674 531.947 50.5273 530.636 50.5273C529.324 50.5273 529.324 52.5674 530.636 52.5674Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.115 33.1484H487.46C487.316 33.1484 487.193 33.1688 487.07 33.23C486.947 33.2708 486.824 33.332 486.742 33.434C486.64 33.5361 486.578 33.6381 486.537 33.7605C486.476 33.8829 486.435 34.0053 486.455 34.1481L486.496 34.4133C486.537 34.5765 486.64 34.7397 486.763 34.8621L486.968 35.0253C487.132 35.1273 487.296 35.1681 487.48 35.1681H488.136C488.279 35.1681 488.402 35.1477 488.525 35.0865C488.648 35.0457 488.771 34.9845 488.853 34.8825C488.955 34.7805 489.017 34.6785 489.058 34.5561C489.119 34.4337 489.16 34.3113 489.14 34.1685L489.099 33.9033C489.058 33.7401 488.955 33.5768 488.833 33.4544L488.628 33.2912C488.464 33.1892 488.3 33.1484 488.115 33.1484Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.681 83.2588C447.992 83.2588 447.992 81.2188 446.681 81.2188C445.369 81.2188 445.369 83.2588 446.681 83.2588Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.894 109.899C375.205 109.899 375.205 107.859 373.894 107.859C372.582 107.859 372.582 109.899 373.894 109.899Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.923 164.122H367.254C367.521 164.122 367.787 164 367.972 163.816C368.074 163.714 368.136 163.612 368.177 163.49C368.238 163.367 368.279 163.245 368.259 163.102C368.259 162.837 368.156 162.572 367.951 162.388C367.746 162.204 367.5 162.082 367.234 162.082H365.902C365.636 162.082 365.369 162.204 365.185 162.388C365.082 162.49 365.021 162.592 364.98 162.714C364.918 162.837 364.877 162.959 364.898 163.102C364.898 163.367 365 163.632 365.205 163.816C365.41 164 365.656 164.122 365.923 164.122Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.832 560.532C440.144 560.532 440.144 558.492 438.832 558.492C437.521 558.492 437.521 560.532 438.832 560.532Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.394 21.3772C275.943 21.6016 275.513 21.826 275.062 22.03C274.939 22.0912 274.836 22.1728 274.775 22.2952C274.693 22.3972 274.631 22.5196 274.59 22.642C274.549 22.7848 274.549 22.9072 274.59 23.05C274.59 23.1929 274.631 23.3153 274.713 23.4377C274.857 23.6621 275.062 23.8457 275.328 23.9069L275.595 23.9477C275.779 23.9477 275.943 23.9069 276.107 23.8049C276.558 23.5805 276.988 23.3561 277.439 23.152C277.562 23.0908 277.664 23.0092 277.726 22.8868C277.808 22.7848 277.869 22.6624 277.91 22.54C277.951 22.3972 277.951 22.2748 277.91 22.132C277.91 21.9892 277.869 21.8668 277.787 21.7444C277.644 21.52 277.439 21.3364 277.172 21.2752L276.906 21.2344C276.722 21.2344 276.558 21.2752 276.394 21.3772Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.72 138.014C1021.27 138.238 1020.84 138.463 1020.39 138.667C1020.27 138.728 1020.17 138.81 1020.1 138.932C1020.02 139.034 1019.96 139.156 1019.92 139.279C1019.88 139.422 1019.88 139.544 1019.92 139.687C1019.92 139.83 1019.96 139.952 1020.04 140.074C1020.19 140.299 1020.39 140.482 1020.66 140.544L1020.92 140.584C1021.11 140.584 1021.27 140.544 1021.44 140.442C1021.89 140.217 1022.32 139.993 1022.77 139.789C1022.89 139.728 1022.99 139.646 1023.05 139.524C1023.14 139.422 1023.2 139.299 1023.24 139.177C1023.28 139.034 1023.28 138.912 1023.24 138.769C1023.24 138.626 1023.2 138.504 1023.12 138.381C1022.97 138.157 1022.77 137.973 1022.5 137.912L1022.23 137.871C1022.05 137.871 1021.89 137.912 1021.72 138.014Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.373 50.3281H245.717C245.574 50.3281 245.451 50.3485 245.328 50.4097C245.205 50.4505 245.082 50.5117 245 50.6137C244.898 50.7157 244.836 50.8178 244.795 50.9402C244.734 51.0626 244.693 51.185 244.713 51.3278L244.754 51.593C244.795 51.7562 244.898 51.9194 245.021 52.0418L245.226 52.205C245.39 52.307 245.554 52.3478 245.738 52.3478H246.394C246.537 52.3478 246.66 52.3274 246.783 52.2662C246.906 52.2254 247.029 52.1642 247.111 52.0622C247.213 51.9602 247.275 51.8582 247.316 51.7358C247.377 51.6134 247.418 51.491 247.398 51.3482L247.357 51.083C247.316 50.9198 247.213 50.7565 247.09 50.6341L246.885 50.4709C246.722 50.3689 246.558 50.3281 246.373 50.3281Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.89 81.4815C284.201 81.4815 284.201 79.4414 282.89 79.4414C281.578 79.4414 281.578 81.4815 282.89 81.4815Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.869 282.485C294.181 282.485 294.181 280.445 292.869 280.445C291.558 280.445 291.558 282.485 292.869 282.485Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.619 307.845C251.394 308.07 251.168 308.294 250.963 308.498C250.861 308.6 250.799 308.702 250.758 308.824C250.697 308.947 250.656 309.069 250.677 309.212C250.677 309.355 250.697 309.477 250.758 309.6C250.799 309.722 250.861 309.844 250.963 309.926L251.168 310.089C251.332 310.191 251.496 310.232 251.681 310.232L251.947 310.191C252.111 310.15 252.275 310.048 252.398 309.926C252.623 309.702 252.849 309.477 253.054 309.273C253.156 309.171 253.218 309.069 253.258 308.947C253.32 308.824 253.361 308.702 253.34 308.559C253.34 308.416 253.32 308.294 253.258 308.172C253.218 308.049 253.156 307.927 253.054 307.845L252.849 307.682C252.685 307.58 252.521 307.539 252.336 307.539L252.07 307.58C251.906 307.621 251.742 307.723 251.619 307.845Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.361 355.156H247.705C247.562 355.156 247.439 355.177 247.316 355.238C247.193 355.279 247.07 355.34 246.988 355.442C246.886 355.544 246.824 355.646 246.783 355.768C246.722 355.891 246.681 356.013 246.701 356.156L246.742 356.421C246.783 356.584 246.886 356.748 247.008 356.87L247.213 357.033C247.377 357.135 247.541 357.176 247.726 357.176H248.381C248.525 357.176 248.648 357.156 248.771 357.094C248.894 357.054 249.017 356.992 249.099 356.89C249.201 356.788 249.263 356.686 249.304 356.564C249.365 356.442 249.406 356.319 249.386 356.176L249.345 355.911C249.304 355.748 249.201 355.585 249.078 355.462L248.873 355.299C248.709 355.197 248.545 355.156 248.361 355.156Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16 355.22C305.472 355.22 305.472 353.18 304.16 353.18C302.849 353.18 302.849 355.22 304.16 355.22Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.664 465.63C343.976 465.63 343.976 463.59 342.664 463.59C341.353 463.59 341.353 465.63 342.664 465.63Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.914 539.024C280.226 539.024 280.226 536.984 278.914 536.984C277.603 536.984 277.603 539.024 278.914 539.024Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.705 578.032C249.017 578.032 249.017 575.992 247.705 575.992C246.394 575.992 246.394 578.032 247.705 578.032Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6794 646.204C98.9909 646.204 98.9909 644.164 97.6794 644.164C96.368 644.164 96.368 646.204 97.6794 646.204Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.625 617.135C194.494 617.135 194.494 606.449 187.625 606.449C180.756 606.449 180.756 617.135 187.625 617.135Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.236 632.894C284.287 632.894 284.287 626.594 280.236 626.594C276.186 626.594 276.186 632.894 280.236 632.894Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.787 580.625H312.131C311.988 580.625 311.865 580.645 311.742 580.707C311.619 580.747 311.496 580.809 311.414 580.911C311.312 581.013 311.25 581.115 311.209 581.237C311.148 581.359 311.107 581.482 311.127 581.625L311.168 581.89C311.209 582.053 311.312 582.216 311.435 582.339L311.64 582.502C311.804 582.604 311.968 582.645 312.152 582.645H312.808C312.951 582.645 313.074 582.624 313.197 582.563C313.32 582.522 313.443 582.461 313.525 582.359C313.627 582.257 313.689 582.155 313.73 582.033C313.791 581.91 313.832 581.788 313.812 581.645L313.771 581.38C313.73 581.217 313.627 581.053 313.504 580.931L313.299 580.768C313.136 580.666 312.972 580.625 312.787 580.625Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.775 65.9971C761.087 65.9971 761.087 63.957 759.775 63.957C758.464 63.957 758.464 65.9971 759.775 65.9971Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.997 81.626C825.308 81.626 825.308 79.5859 823.997 79.5859C822.685 79.5859 822.685 81.626 823.997 81.626Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.644 195.868C968.956 195.868 968.956 193.828 967.644 193.828C966.333 193.828 966.333 195.868 967.644 195.868Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.128 172.829C897.439 172.829 897.439 170.789 896.128 170.789C894.817 170.789 894.817 172.829 896.128 172.829Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.415 17.337C852.726 17.337 852.726 15.2969 851.415 15.2969C850.103 15.2969 850.103 17.337 851.415 17.337Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.964 533.177C782.275 533.177 782.275 531.137 780.964 531.137C779.652 531.137 779.652 533.177 780.964 533.177Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.661 614.411C737.972 614.411 737.972 612.371 736.661 612.371C735.349 612.371 735.349 614.411 736.661 614.411Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.136 390.204C934.448 390.204 934.448 388.164 933.136 388.164C931.825 388.164 931.825 390.204 933.136 390.204Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.472 550.11C851.784 550.11 851.784 548.07 850.472 548.07C849.161 548.07 849.161 550.11 850.472 550.11Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.964 446.41H970.308C970.165 446.41 970.042 446.431 969.919 446.492C969.796 446.533 969.673 446.594 969.591 446.696C969.489 446.798 969.427 446.9 969.386 447.022C969.325 447.145 969.284 447.267 969.304 447.41L969.345 447.675C969.386 447.838 969.489 448.001 969.612 448.124L969.817 448.287C969.981 448.389 970.144 448.43 970.329 448.43H970.985C971.128 448.43 971.251 448.409 971.374 448.348C971.497 448.307 971.62 448.246 971.702 448.144C971.804 448.042 971.866 447.94 971.907 447.818C971.968 447.695 972.009 447.573 971.989 447.43L971.948 447.165C971.907 447.002 971.804 446.839 971.681 446.716L971.476 446.553C971.312 446.451 971.149 446.41 970.964 446.41Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.886 524.896C976.661 525.12 976.435 525.345 976.23 525.549C976.128 525.651 976.067 525.753 976.026 525.875C975.964 525.998 975.923 526.12 975.944 526.263C975.944 526.406 975.964 526.528 976.026 526.65C976.067 526.773 976.128 526.895 976.23 526.977L976.435 527.14C976.599 527.242 976.763 527.283 976.948 527.283L977.214 527.242C977.378 527.201 977.542 527.099 977.665 526.977C977.89 526.752 978.116 526.528 978.321 526.324C978.423 526.222 978.485 526.12 978.526 525.998C978.587 525.875 978.628 525.753 978.608 525.61C978.608 525.467 978.587 525.345 978.526 525.222C978.485 525.1 978.423 524.977 978.321 524.896L978.116 524.733C977.952 524.631 977.788 524.59 977.603 524.59L977.337 524.631C977.173 524.671 977.009 524.773 976.886 524.896Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.14 549.614C930.452 549.614 930.452 547.574 929.14 547.574C927.829 547.574 927.829 549.614 929.14 549.614Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.546 622.349C909.857 622.349 909.857 620.309 908.546 620.309C907.235 620.309 907.235 622.349 908.546 622.349Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.312 612.005C397.623 612.005 397.623 609.965 396.312 609.965C395 609.965 395 612.005 396.312 612.005Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.869 649.317C344.181 649.317 344.181 647.277 342.869 647.277C341.558 647.277 341.558 649.317 342.869 649.317Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.021 475.321C426.332 475.321 426.332 473.281 425.021 473.281C423.709 473.281 423.709 475.321 425.021 475.321Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.049 239.81V239.157C337.049 239.014 337.029 238.892 336.968 238.77C336.927 238.647 336.865 238.525 336.763 238.443C336.66 238.341 336.558 238.28 336.435 238.239C336.312 238.178 336.189 238.137 336.045 238.158L335.779 238.198C335.615 238.239 335.451 238.341 335.328 238.464L335.164 238.668C335.062 238.831 335.021 238.994 335.021 239.178V239.831C335.021 239.973 335.041 240.096 335.103 240.218C335.144 240.341 335.205 240.463 335.308 240.545C335.41 240.647 335.513 240.708 335.636 240.749C335.759 240.81 335.881 240.851 336.025 240.83L336.291 240.789C336.455 240.749 336.619 240.647 336.742 240.524L336.906 240.32C337.009 240.157 337.049 239.994 337.049 239.81Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.705 186.236V185.583C252.705 185.44 252.685 185.318 252.623 185.195C252.582 185.073 252.521 184.951 252.418 184.869C252.316 184.767 252.213 184.706 252.09 184.665C251.967 184.604 251.845 184.563 251.701 184.583L251.435 184.624C251.271 184.665 251.107 184.767 250.984 184.889L250.82 185.093C250.717 185.257 250.676 185.42 250.676 185.603V186.256C250.676 186.399 250.697 186.521 250.758 186.644C250.799 186.766 250.861 186.889 250.963 186.97C251.066 187.072 251.168 187.134 251.291 187.174C251.414 187.236 251.537 187.276 251.681 187.256L251.947 187.215C252.111 187.174 252.275 187.072 252.398 186.95L252.562 186.746C252.664 186.583 252.705 186.419 252.705 186.236Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.873 119.773H468.218C468.074 119.773 467.951 119.794 467.828 119.855C467.705 119.896 467.582 119.957 467.5 120.059C467.398 120.161 467.337 120.263 467.296 120.385C467.234 120.508 467.193 120.63 467.214 120.773L467.255 121.038C467.296 121.201 467.398 121.365 467.521 121.487L467.726 121.65C467.89 121.752 468.054 121.793 468.238 121.793H468.894C469.037 121.793 469.16 121.773 469.283 121.712C469.406 121.671 469.529 121.61 469.611 121.508C469.714 121.405 469.775 121.304 469.816 121.181C469.878 121.059 469.918 120.936 469.898 120.793L469.857 120.528C469.816 120.365 469.714 120.202 469.591 120.079L469.386 119.916C469.222 119.814 469.058 119.773 468.873 119.773Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.033 406.747C394.345 406.747 394.345 404.707 393.033 404.707C391.722 404.707 391.722 406.747 393.033 406.747Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.873 335.63C470.185 335.63 470.185 333.59 468.873 333.59C467.562 333.59 467.562 335.63 468.873 335.63Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.771 274.755C420.082 274.755 420.082 272.715 418.771 272.715C417.459 272.715 417.459 274.755 418.771 274.755Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.599 190.603C437.91 190.603 437.91 188.562 436.599 188.562C435.287 188.562 435.287 190.603 436.599 190.603Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.312 148.884C542.623 148.884 542.623 146.844 541.312 146.844C540 146.844 540 148.884 541.312 148.884Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.685 406.587C803.997 406.587 803.997 404.547 802.685 404.547C801.374 404.547 801.374 406.587 802.685 406.587Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.259 550.11C689.57 550.11 689.57 548.07 688.259 548.07C686.947 548.07 686.947 550.11 688.259 550.11Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.357 427.864C738.669 427.864 738.669 425.824 737.357 425.824C736.046 425.824 736.046 427.864 737.357 427.864Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.271 577.524C617.583 577.524 617.583 575.484 616.271 575.484C614.96 575.484 614.96 577.524 616.271 577.524Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.697 242.153C712.009 242.153 712.009 240.113 710.697 240.113C709.386 240.113 709.386 242.153 710.697 242.153Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.156 342.079C869.468 342.079 869.468 340.039 868.156 340.039C866.845 340.039 866.845 342.079 868.156 342.079Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.406 335.63C780.718 335.63 780.718 333.59 779.406 333.59C778.095 333.59 778.095 335.63 779.406 335.63Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.775 634.892C481.087 634.892 481.087 632.852 479.775 632.852C478.464 632.852 478.464 634.892 479.775 634.892Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.685 518.345C553.996 518.345 553.996 516.305 552.685 516.305C551.373 516.305 551.373 518.345 552.685 518.345Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.582 398.489C508.894 398.489 508.894 396.449 507.582 396.449C506.271 396.449 506.271 398.489 507.582 398.489Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.751 479.075C820.062 479.075 820.062 477.035 818.751 477.035C817.439 477.035 817.439 479.075 818.751 479.075Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.275 428.126C858.587 428.126 858.587 426.086 857.275 426.086C855.964 426.086 855.964 428.126 857.275 428.126Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.333 262.919C792.644 262.919 792.644 260.879 791.333 260.879C790.021 260.879 790.021 262.919 791.333 262.919Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.07 421.95C688.382 421.95 688.382 419.91 687.07 419.91C685.759 419.91 685.759 421.95 687.07 421.95Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.558 375.618C592.869 375.618 592.869 373.578 591.558 373.578C590.247 373.578 590.247 375.618 591.558 375.618Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.337 335.63C628.648 335.63 628.648 333.59 627.337 333.59C626.025 333.59 626.025 335.63 627.337 335.63Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.275 292.501C658.587 292.501 658.587 290.461 657.275 290.461C655.964 290.461 655.964 292.501 657.275 292.501Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.558 292.501C592.869 292.501 592.869 290.461 591.558 290.461C590.247 290.461 590.247 292.501 591.558 292.501Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.64 126.036C767.952 126.036 767.952 123.996 766.64 123.996C765.329 123.996 765.329 126.036 766.64 126.036Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.07 92.0088C683.382 92.0088 683.382 89.9688 682.07 89.9688C680.759 89.9688 680.759 92.0088 682.07 92.0088Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.247 37.1885C636.558 37.1885 636.558 35.1484 635.247 35.1484C633.935 35.1484 633.935 37.1885 635.247 37.1885Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.837 100.677C576.148 100.677 576.148 98.6367 574.837 98.6367C573.525 98.6367 573.525 100.677 574.837 100.677Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.841 17.9297H565.185C565.042 17.9297 564.919 17.9501 564.796 18.0113C564.673 18.0521 564.55 18.1133 564.468 18.2153C564.365 18.3173 564.304 18.4193 564.263 18.5417C564.201 18.6641 564.16 18.7865 564.181 18.9293L564.222 19.1945C564.263 19.3577 564.365 19.5209 564.488 19.6433L564.693 19.8066C564.857 19.9086 565.021 19.9494 565.205 19.9494H565.861C566.005 19.9494 566.128 19.929 566.251 19.8678C566.374 19.827 566.497 19.7658 566.578 19.6638C566.681 19.5617 566.742 19.4597 566.783 19.3373C566.845 19.2149 566.886 19.0925 566.865 18.9497L566.824 18.6845C566.783 18.5213 566.681 18.3581 566.558 18.2357L566.353 18.0725C566.189 17.9705 566.025 17.9297 565.841 17.9297Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.463 -1.89844H397.132C396.865 -1.89844 396.599 -1.77604 396.414 -1.59243C396.312 -1.49043 396.25 -1.38842 396.209 -1.26602C396.148 -1.14361 396.107 -1.0212 396.127 -0.878398C396.127 -0.613187 396.23 -0.34798 396.435 -0.164373C396.64 0.0192344 396.886 0.141642 397.152 0.141642H398.484C398.75 0.141642 399.017 0.0192344 399.201 -0.164373C399.304 -0.266377 399.365 -0.36838 399.406 -0.490785C399.468 -0.61319 399.509 -0.735592 399.488 -0.878398C399.488 -1.14361 399.386 -1.40882 399.181 -1.59243C398.976 -1.77604 398.73 -1.89844 398.463 -1.89844Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.316 20.582H346.66C346.517 20.582 346.394 20.6024 346.271 20.6636C346.148 20.7044 346.025 20.7656 345.943 20.8676C345.841 20.9696 345.779 21.0716 345.738 21.1941C345.677 21.3165 345.636 21.4389 345.656 21.5817L345.697 21.8469C345.738 22.0101 345.841 22.1733 345.963 22.2957L346.168 22.4589C346.332 22.5609 346.496 22.6017 346.681 22.6017H347.336C347.48 22.6017 347.603 22.5813 347.726 22.5201C347.849 22.4793 347.972 22.4181 348.054 22.3161C348.156 22.2141 348.218 22.1121 348.259 21.9897C348.32 21.8673 348.361 21.7449 348.341 21.6021L348.3 21.3369C348.259 21.1737 348.156 21.0104 348.033 20.888L347.828 20.7248C347.664 20.6228 347.5 20.582 347.316 20.582Z",
    fill: "#FFF6E3"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M877.827 251.683C886.804 226.57 873.633 198.967 848.408 190.03C823.183 181.093 795.457 194.205 786.48 219.318C777.503 244.431 790.674 272.034 815.899 280.972C841.124 289.909 868.85 276.796 877.827 251.683Z",
    fill: "#BBAEFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M867.688 247.888C875.941 224.543 865.083 199.129 843.256 188.528C845.075 188.938 846.895 189.439 848.696 190.077C873.953 198.915 887.214 226.472 878.336 251.616C869.458 276.761 841.772 289.978 816.521 281.124C814.72 280.486 812.994 279.751 811.314 278.944C834.983 284.277 859.451 271.239 867.704 247.894L867.688 247.888Z",
    fill: "#6928FF"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M866.565 269.479C860.697 267.846 854.796 266.028 848.776 265.607C839.662 264.968 830.683 267.56 821.839 269.867C815.633 271.483 809.326 272.964 802.985 274.058C797.134 269.665 792.315 263.975 788.967 257.443C798.03 255.237 807.28 253.116 816.191 255.456C820.824 256.668 825.069 259.042 829.516 260.81C841.708 265.624 855.743 265.658 867.969 260.911C870.353 259.985 872.686 258.89 875.071 257.965C872.822 262.241 869.93 266.112 866.565 269.513V269.479ZM792.45 207.815C790.336 210.828 788.544 214.077 787.157 217.545C790.472 220.946 793.718 224.413 797.591 227.141C803.391 231.215 810.476 233.42 817.561 233.353C832.306 233.218 845.665 223.706 860.41 223.302C866.971 223.117 873.397 224.767 879.771 226.45C878.013 217.242 873.633 208.943 867.377 202.36C853.088 204.178 840.423 215.676 825.711 217.343C814.01 218.673 802.883 213.69 792.45 207.831V207.815ZM811.406 191.889C814.906 192.95 818.474 193.741 822.143 194.044C830.209 194.701 838.275 192.933 845.952 190.374C846.527 190.189 847.102 189.97 847.677 189.768C843.382 188.337 838.833 187.462 834.065 187.277C825.965 186.957 818.271 188.657 811.423 191.889H811.406Z",
    fill: "#FFD079"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M785.737 221.573C779.616 224.401 762.097 230.882 767.052 238.34C769.199 241.555 773.224 243.39 777.096 244.871C809.394 257.228 846.747 257.514 880.211 248.626C880.989 248.424 881.767 248.205 882.545 247.986C887.601 246.572 894.263 244.518 896.681 239.939C899.437 234.737 894.348 229.485 890.137 226.303C889.934 226.152 889.748 226.017 889.545 225.865C888.108 224.822 881.682 220.849 878.064 220.057L875.595 214.132C888.209 217.919 922.773 229.889 912.339 246.589C910.141 250.124 906.658 252.918 902.921 255.258C893.671 261.1 882.849 264.804 871.739 267.009C845.614 272.228 817.29 271.487 791.588 264.888C779.65 261.824 768.168 256.975 758.834 249.737C751.038 243.71 745.272 234.754 753.017 226.842C758.124 221.623 765.834 218.424 773.021 216.017C775.371 215.226 787.715 211.893 790.15 211.32L785.686 221.556L785.737 221.573Z",
    fill: "url(#paint4_linear_2040_26973)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M912.373 240.579C910.209 244.131 906.692 246.909 902.955 249.249C893.705 255.091 882.883 258.794 871.773 261C845.648 266.218 817.324 265.478 791.622 258.878C779.684 255.815 768.202 250.966 758.868 243.727C754.657 240.478 751.039 236.354 749.821 232.027C747.86 238.458 752.747 245.007 758.868 249.737C768.202 256.959 779.684 261.824 791.622 264.888C817.324 271.487 845.648 272.228 871.773 267.009C882.866 264.787 893.705 261.101 902.955 255.259C906.675 252.902 910.192 250.141 912.373 246.589C914.419 243.222 914.758 240.074 913.895 237.179C913.574 238.29 913.067 239.418 912.373 240.579Z",
    fill: "url(#paint5_linear_2040_26973)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M693.312 292.468C699.388 408.011 806.947 516.894 709.939 588.277C708.259 589.521 706.537 590.725 704.796 591.908C674.468 612.329 636.886 621.612 600.472 618.246C564.201 614.9 528.566 608.922 492.89 602.394C456.681 595.784 437.573 582.214 387.89 569.651C147.696 527.293 40.9427 638.859 -5.02047 681.293C-24.6926 699.47 -38.75 723.237 -48.9959 747.718C-53.914 759.448 -57.9713 771.505 -61.1886 783.807C-62.4386 788.601 -63.6066 793.579 -64.9796 798.332L-5.02078 694.932C-3.87323 694.932 -1.10682 676.775 -0.225672 674.919C2.80712 668.697 9.15959 658.945 12.4793 652.866C19.1186 640.788 27.0285 630.2 35.0408 618.98C50.6555 597.11 72.5408 573.69 94.9179 558.553C118.996 542.273 140.02 529.318 167.234 518.954C225.389 496.799 292.152 486.802 352.582 502.633C383.074 510.63 416.476 521.505 446.599 530.951C477.337 540.58 496.517 547.353 528.873 558.818C551.845 566.958 587.849 573.343 612.296 573.629C635.328 573.874 653.238 563.061 673.771 552.453C690.615 543.762 694.96 537.458 703.013 520.342C715.656 493.494 716.599 465.993 701.64 442.226C694.14 430.291 686.558 417.256 678.218 405.892C669.509 393.999 661.476 381.595 654.181 368.783C587.609 251.904 621.252 148.985 723.951 72.5662C834.173 -9.4501 1020.4 1.56402 1020.4 1.56402C881.509 39.6101 683.547 106.786 693.312 292.468Z",
    fill: "#1E0659"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M396.271 764.993C317.623 625.452 358.361 451.555 485.451 359.895C474.324 364.526 463.341 369.748 452.562 375.766C301.619 460.083 247.931 650.259 332.623 800.531C417.316 950.804 608.341 1004.25 759.284 919.937C770.062 913.919 780.267 907.309 790.021 900.271C645.226 960.514 474.898 904.535 396.25 764.993H396.271Z",
    fill: "#9980FF"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M810.138 488.157C808.933 486.503 807.704 484.888 806.449 483.285C806.309 483.348 806.17 483.411 806.03 483.474C807.425 485.002 808.781 486.566 810.138 488.157Z",
    fill: "url(#paint6_linear_2040_26973)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M866.882 628.023C912.793 628.023 950.011 590.971 950.011 545.264C950.011 499.557 912.793 462.504 866.882 462.504C820.971 462.504 783.753 499.557 783.753 545.264C783.753 590.971 820.971 628.023 866.882 628.023Z",
    fill: "#BBAEFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M947.794 564.215C937.737 567.077 927.475 569.675 918.305 574.426C904.405 581.618 893.604 593.432 882.766 604.693C875.161 612.594 867.285 620.398 858.973 627.639C846.449 626.437 834.3 622.422 823.516 615.868C834.79 604.558 846.389 593.188 861.523 588.648C869.399 586.289 877.727 585.975 885.826 584.562C907.993 580.704 928.529 568.241 942.129 550.399C944.782 546.919 947.196 543.228 949.843 539.749C950.392 548.007 949.68 556.254 947.799 564.22L947.794 564.215ZM783.922 540.257C783.536 546.546 783.851 552.899 784.938 559.209C792.842 561.211 800.718 563.397 808.828 563.917C820.961 564.696 833.317 561.585 843.623 555.161C865.045 541.805 876.02 515.965 897.192 502.208C906.623 496.082 917.489 492.749 928.334 489.534C917.478 477.65 903.579 469.414 888.527 465.372C869.279 480.789 861.115 508.886 841.111 524.472C825.217 536.853 804.464 539.516 783.922 540.252V540.257ZM797.261 500.055C803.344 498.48 809.269 496.45 814.884 493.62C827.25 487.386 837.464 477.586 846.368 467.006C847.031 466.216 847.683 465.404 848.335 464.598C840.769 466.324 833.317 469.122 826.207 473.099C814.09 479.869 804.355 489.22 797.267 500.06L797.261 500.055Z",
    fill: "#FFD079"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M928.41 489.578C930.589 491.981 932.66 494.541 934.601 497.236C948.631 492.176 957.833 490.59 959.491 493.534C961.149 496.478 954.98 503.481 943.331 512.767C927.948 525.052 902.97 541.362 873.845 557.635C844.737 573.897 817.743 586.619 799.191 593.292C785.161 598.352 775.942 599.943 774.284 597.004C772.626 594.06 778.78 587.069 790.423 577.782C789.124 574.73 788.009 571.64 787.085 568.534C747.187 595.094 722.579 616.8 726.477 623.716C730.374 630.632 761.798 621.01 805.355 600.944C827.022 590.97 851.678 578.421 877.444 564.026C903.209 549.631 926.833 535.209 946.674 521.994C986.572 495.434 1011.19 473.744 1007.29 466.828C1003.4 459.912 971.961 469.518 928.404 489.584L928.41 489.578Z",
    fill: "url(#paint7_linear_2040_26973)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.3 466.736C1006.69 465.654 1005.41 464.977 1003.52 464.68C1001.24 473.717 977.924 493.372 942.678 516.831C922.838 530.047 899.214 544.468 873.449 558.863C847.683 573.258 823.027 585.808 801.36 595.781C764.603 612.714 736.489 622.206 726.259 620.604C725.96 621.8 726.02 622.812 726.477 623.619C730.374 630.535 761.798 620.913 805.355 600.847C827.022 590.873 851.678 578.323 877.444 563.929C903.209 549.534 926.833 535.112 946.674 521.897C986.572 495.336 1011.19 473.647 1007.29 466.731L1007.3 466.736Z",
    fill: "url(#paint8_linear_2040_26973)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M756.629 414.594L770.7 432.944C770.789 433.083 770.891 433.221 771.017 433.348C772.006 434.382 773.654 434.42 774.681 433.436C775.72 432.452 775.758 430.811 774.77 429.789C774.656 429.662 774.516 429.549 774.389 429.461L756.629 414.606V414.594Z",
    fill: "url(#paint9_linear_2040_26973)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M758.632 416.676L770.979 432.754C771.055 432.88 771.144 432.994 771.258 433.107C772.12 434.004 773.553 434.041 774.465 433.183C775.365 432.325 775.404 430.899 774.541 429.99C774.44 429.877 774.326 429.788 774.199 429.7L758.632 416.676Z",
    fill: "url(#paint10_linear_2040_26973)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M771.461 430.066C772.26 429.309 773.515 429.347 774.275 430.129C775.036 430.924 774.998 432.174 774.212 432.931C773.413 433.688 772.158 433.65 771.398 432.868C770.637 432.073 770.675 430.823 771.461 430.066Z",
    fill: "url(#paint11_linear_2040_26973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M925.378 570.993C942.671 532.276 927.582 487.397 891.721 466.296C894.775 467.246 897.817 468.351 900.809 469.688C942.772 488.253 961.676 537.12 943.068 578.823C924.461 620.527 875.335 639.281 833.385 620.691C830.393 619.354 827.543 617.861 824.783 616.252C864.51 628.614 908.111 609.723 925.404 571.005L925.378 570.993Z",
    fill: "#6928FF"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M350.166 581.582L386.642 629.136C386.867 629.504 387.154 629.85 387.461 630.177C390.023 632.849 394.285 632.951 396.97 630.401C399.654 627.851 399.756 623.608 397.195 620.935C396.888 620.609 396.56 620.323 396.191 620.078L350.166 581.582Z",
    fill: "url(#paint12_linear_2040_26973)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M355.351 586.966L387.359 628.645C387.564 628.971 387.789 629.257 388.076 629.542C390.31 631.888 394.039 631.97 396.375 629.726C398.732 627.502 398.814 623.789 396.56 621.463C396.293 621.178 396.006 620.933 395.679 620.709L355.33 586.945L355.351 586.966Z",
    fill: "url(#paint13_linear_2040_26973)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M388.629 621.693C390.679 619.734 393.937 619.816 395.904 621.856C397.871 623.896 397.789 627.14 395.74 629.098C393.691 631.057 390.433 630.975 388.465 628.935C386.498 626.895 386.58 623.651 388.629 621.693Z",
    fill: "url(#paint14_linear_2040_26973)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M886.841 83.6016L924.238 132.359C924.484 132.727 924.751 133.094 925.079 133.42C927.702 136.154 932.066 136.256 934.812 133.645C937.558 131.033 937.661 126.688 935.038 123.954C934.73 123.628 934.382 123.322 934.013 123.077L886.841 83.622V83.6016Z",
    fill: "url(#paint15_linear_2040_26973)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M892.148 89.1328L924.956 131.872C925.161 132.199 925.407 132.505 925.673 132.791C927.968 135.177 931.779 135.279 934.177 132.995C936.575 130.71 936.677 126.915 934.382 124.528C934.095 124.243 933.808 123.977 933.48 123.753L892.128 89.1328H892.148Z",
    fill: "url(#paint16_linear_2040_26973)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M926.247 124.704C928.357 122.704 931.697 122.786 933.706 124.867C935.714 126.968 935.632 130.294 933.542 132.293C931.431 134.292 928.091 134.211 926.083 132.13C924.074 130.028 924.156 126.703 926.247 124.704Z",
    fill: "url(#paint17_linear_2040_26973)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M833.853 658.904L799.837 671.247C698.443 506.47 532.685 414.299 532.685 414.299L574.16 340.203C574.16 340.203 771.784 447.409 833.853 658.884V658.904Z",
    fill: "url(#paint18_linear_2040_26973)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M648.197 434.94C612.706 341.158 563.156 358.947 563.156 358.947L551.312 379.45L551.189 379.654L539.345 400.157C539.345 400.157 548.833 451.75 648.095 435.124L648.341 435.267C648.341 435.267 648.3 435.165 648.279 435.103C648.341 435.103 648.402 435.103 648.464 435.083L648.218 434.94H648.197Z",
    fill: "url(#paint19_linear_2040_26973)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M550.054 326.844L508.576 400.941L532.688 414.318L574.165 340.221L550.054 326.844Z",
    fill: "#6928FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M425.308 308.971C385.308 380.414 410.021 470.015 480.533 509.102C496.927 518.181 514.324 523.689 531.906 525.974C494.898 480.786 487.439 415.279 518.136 360.442C548.853 305.584 608.751 277.431 666.824 284.959C655.636 271.29 641.763 259.458 625.37 250.359C554.857 211.271 465.287 237.527 425.287 308.971H425.308Z",
    fill: "url(#paint20_linear_2040_26973)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M540.923 329.802C573.792 295.488 620.861 279.024 666.824 284.981C655.636 271.313 641.763 259.48 625.37 250.381C566.128 217.557 493.443 230.858 447.992 278.31L540.902 329.802H540.923Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M339.017 365.89C399.201 399.245 461.476 416.871 516.148 419.136C519.693 402.244 525.82 385.536 534.734 369.623C543.648 353.71 554.693 339.736 567.255 327.842C536.537 282.818 488.689 239.384 428.525 206.029C332.951 153.048 231.988 139.665 164.836 164.595C178.873 234.529 243.443 312.888 339.017 365.869V365.89Z",
    fill: "url(#paint21_linear_2040_26973)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.14 275.008C229.119 280.822 233.135 284.739 233.135 284.739C233.135 285.025 263.361 213.071 305.062 159.417C305.062 159.417 293.996 157.152 290.328 156.785C257.828 166.659 213.197 230.024 224.119 274.987L224.14 275.008Z",
    fill: "#6928FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M499.017 372.314C538.771 394.347 577.091 406.445 599.673 405.649C588.464 386.105 557.972 360.053 518.218 338.02C478.464 315.987 440.144 303.89 417.562 304.685C428.771 324.229 459.283 350.281 499.017 372.314Z",
    fill: "url(#paint22_linear_2040_26973)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M598.587 405.649C598.935 405.649 599.324 405.649 599.673 405.649C588.464 386.105 557.972 360.053 518.218 338.02C478.464 315.987 440.144 303.89 417.562 304.685C417.746 304.991 417.972 305.297 418.136 305.603L598.607 405.628L598.587 405.649Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M224.201 275.062C233.689 255.151 244.058 234.852 255.308 214.758C266.558 194.663 278.299 175.282 290.328 156.779C243.115 149.087 199.447 151.76 164.836 164.612C172.07 200.661 192.787 239.157 224.201 275.062Z",
    fill: "url(#paint23_linear_2040_26973)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M256.435 212.82C267.357 193.439 278.709 174.69 290.349 156.779C243.135 149.087 199.467 151.76 164.857 164.612L256.455 212.82H256.435Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M312.972 246.73C304.672 261.52 309.816 280.146 324.427 288.245C339.037 296.345 357.644 290.877 365.923 276.087C374.201 261.296 369.078 242.67 354.468 234.571C339.877 226.492 321.25 231.939 312.972 246.73Z",
    fill: "url(#paint24_linear_2040_26973)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.22
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M164.836 164.61L533.279 372.372C533.771 371.454 534.242 370.556 534.734 369.638C543.648 353.726 554.693 339.751 567.255 327.858C536.537 282.833 488.689 239.4 428.525 206.044C332.951 153.064 232.336 139.619 164.836 164.61Z",
    fill: "#CFCFCF"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M315.513 229.896C298.033 243.054 294.57 267.821 307.787 285.223C321.004 302.624 345.882 306.072 363.361 292.914C380.841 279.755 384.304 254.989 371.086 237.587C357.869 220.185 332.992 216.737 315.513 229.896ZM357.541 237.444C370.841 247.399 373.504 266.189 363.504 279.408C353.504 292.628 334.632 295.301 321.353 285.345C308.054 275.389 305.39 256.6 315.39 243.381C325.39 230.14 344.263 227.488 357.541 237.444Z",
    fill: "url(#paint25_linear_2040_26973)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M325.554 293.377C325.738 292.336 326.722 291.643 327.767 291.826C328.812 292.01 329.509 292.989 329.324 294.03C329.14 295.07 328.156 295.764 327.111 295.58C326.066 295.396 325.369 294.417 325.554 293.377Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M315.492 287.752C315.677 286.711 316.66 286.018 317.705 286.201C318.75 286.385 319.447 287.364 319.263 288.405C319.078 289.445 318.095 290.139 317.049 289.955C316.004 289.771 315.308 288.792 315.492 287.752Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M304.099 270.33C304.283 269.29 305.267 268.596 306.312 268.779C307.357 268.963 308.054 269.942 307.869 270.983C307.685 272.023 306.701 272.717 305.656 272.533C304.611 272.35 303.914 271.37 304.099 270.33Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M308.177 279.752C308.361 278.711 309.345 278.018 310.39 278.201C311.435 278.385 312.131 279.364 311.947 280.405C311.763 281.445 310.779 282.139 309.734 281.955C308.689 281.771 307.992 280.792 308.177 279.752Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M302.664 260.025C302.849 258.985 303.832 258.291 304.877 258.475C305.922 258.658 306.619 259.638 306.435 260.678C306.25 261.719 305.267 262.412 304.222 262.229C303.177 262.045 302.48 261.066 302.664 260.025Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M306.517 248.534C307.562 248.677 308.279 249.656 308.136 250.696C307.992 251.737 307.008 252.451 305.963 252.308C304.918 252.165 304.201 251.186 304.345 250.145C304.488 249.105 305.472 248.391 306.517 248.534Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M311.865 238.358C312.91 238.501 313.627 239.48 313.484 240.52C313.34 241.561 312.357 242.275 311.312 242.132C310.267 241.989 309.549 241.01 309.693 239.97C309.836 238.929 310.82 238.215 311.865 238.358Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M329.037 226.487C330.082 226.63 330.799 227.609 330.656 228.649C330.513 229.69 329.529 230.404 328.484 230.261C327.439 230.118 326.722 229.139 326.865 228.099C327.009 227.058 327.992 226.344 329.037 226.487Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M319.693 230.827C320.738 230.97 321.455 231.949 321.312 232.989C321.168 234.03 320.185 234.744 319.14 234.601C318.095 234.458 317.377 233.479 317.521 232.438C317.664 231.398 318.648 230.684 319.693 230.827Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M339.324 224.772C340.369 224.915 341.086 225.894 340.943 226.935C340.8 227.975 339.816 228.689 338.771 228.546C337.726 228.403 337.009 227.424 337.152 226.384C337.295 225.343 338.279 224.629 339.324 224.772Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M353.402 229.162C353.218 230.203 352.234 230.897 351.189 230.713C350.144 230.529 349.447 229.55 349.632 228.51C349.816 227.469 350.8 226.776 351.845 226.959C352.89 227.143 353.586 228.122 353.402 229.162Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M363.464 234.811C363.279 235.851 362.295 236.545 361.25 236.361C360.205 236.178 359.509 235.199 359.693 234.158C359.877 233.118 360.861 232.424 361.906 232.608C362.951 232.791 363.648 233.77 363.464 234.811Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M374.836 252.233C374.652 253.273 373.668 253.967 372.623 253.783C371.578 253.6 370.882 252.62 371.066 251.58C371.25 250.539 372.234 249.846 373.279 250.029C374.324 250.213 375.021 251.192 374.836 252.233Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M370.779 242.807C370.595 243.847 369.611 244.541 368.566 244.357C367.521 244.174 366.824 243.195 367.009 242.154C367.193 241.114 368.177 240.42 369.222 240.604C370.267 240.787 370.964 241.767 370.779 242.807Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M376.271 262.537C376.087 263.578 375.103 264.272 374.058 264.088C373.013 263.904 372.316 262.925 372.5 261.885C372.685 260.844 373.668 260.151 374.714 260.334C375.759 260.518 376.455 261.497 376.271 262.537Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M372.418 274.019C371.373 273.876 370.656 272.897 370.8 271.856C370.943 270.816 371.927 270.102 372.972 270.245C374.017 270.388 374.734 271.367 374.591 272.407C374.447 273.448 373.463 274.162 372.418 274.019Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M367.07 284.202C366.025 284.06 365.308 283.08 365.451 282.04C365.595 281 366.578 280.286 367.623 280.428C368.668 280.571 369.386 281.55 369.242 282.591C369.099 283.631 368.115 284.345 367.07 284.202Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M349.898 296.05C348.853 295.907 348.136 294.928 348.279 293.888C348.422 292.847 349.406 292.133 350.451 292.276C351.496 292.419 352.213 293.398 352.07 294.438C351.927 295.479 350.943 296.193 349.898 296.05Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M359.242 291.726C358.197 291.583 357.48 290.604 357.623 289.563C357.767 288.523 358.75 287.809 359.795 287.952C360.841 288.095 361.558 289.074 361.414 290.114C361.271 291.155 360.287 291.869 359.242 291.726Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M339.611 297.788C338.566 297.646 337.849 296.666 337.992 295.626C338.136 294.585 339.119 293.871 340.164 294.014C341.209 294.157 341.927 295.136 341.783 296.177C341.64 297.217 340.656 297.931 339.611 297.788Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2040_26973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(565.748 75.3687) scale(619.614 584.797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.438452,
    stopColor: "#3A1B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2040_26973",
    x1: 846.26,
    y1: 385.65,
    x2: 902.021,
    y2: 372.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2040_26973",
    x1: 851.117,
    y1: 384.792,
    x2: 899.994,
    y2: 373.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2040_26973",
    x1: 880.746,
    y1: 383.909,
    x2: 892.905,
    y2: 380.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2040_26973",
    x1: 749.351,
    y1: 270.445,
    x2: 884.996,
    y2: 171.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#D7491A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2DC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2040_26973",
    x1: 749.382,
    y1: 270.446,
    x2: 841.238,
    y2: 167.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2040_26973",
    x1: 806.03,
    y1: 488.157,
    x2: 810.973,
    y2: 487.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2040_26973",
    x1: 726.073,
    y1: 625.944,
    x2: 1019.99,
    y2: 491.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#D7491A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2DC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2040_26973",
    x1: 726.075,
    y1: 625.847,
    x2: 1019.88,
    y2: 491.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2040_26973",
    x1: 756.629,
    y1: 434.15,
    x2: 779,
    y2: 428.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2040_26973",
    x1: 758.632,
    y1: 433.804,
    x2: 778.243,
    y2: 428.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2040_26973",
    x1: 770.849,
    y1: 433.477,
    x2: 775.541,
    y2: 432.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2040_26973",
    x1: 350.166,
    y1: 632.249,
    x2: 408.156,
    y2: 617.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2040_26973",
    x1: 355.33,
    y1: 631.357,
    x2: 406.179,
    y2: 618.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2040_26973",
    x1: 387.04,
    y1: 630.517,
    x2: 399.185,
    y2: 627.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2040_26973",
    x1: 886.841,
    y1: 135.539,
    x2: 946.272,
    y2: 120.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2040_26973",
    x1: 892.128,
    y1: 134.646,
    x2: 944.219,
    y2: 121.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2040_26973",
    x1: 924.626,
    y1: 133.743,
    x2: 937.061,
    y2: 130.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2040_26973",
    x1: 555.725,
    y1: 370.79,
    x2: 791.938,
    y2: 633.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE461D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FF9E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2040_26973",
    x1: 539.345,
    y1: 438.425,
    x2: 661.738,
    y2: 395.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2040_26973",
    x1: 406.164,
    y1: 525.974,
    x2: 718.26,
    y2: 453.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2040_26973",
    x1: 420.938,
    y1: 445.48,
    x2: 330.801,
    y2: 118.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2040_26973",
    x1: 417.562,
    y1: 405.686,
    x2: 605.468,
    y2: 316.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2040_26973",
    x1: 164.836,
    y1: 275.062,
    x2: 312.581,
    y2: 235.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2040_26973",
    x1: 309.003,
    y1: 291.993,
    x2: 380.942,
    y2: 273.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2040_26973",
    x1: 299.758,
    y1: 300.907,
    x2: 393.423,
    y2: 276.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#D7491A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2DC3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2040_26973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1020,
    height: 683,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaketebgMobile);
export default __webpack_public_path__ + "static/media/raketebg_mobile.e272c1f6aa280857a672cd74aa9536df.svg";
export { ForwardRef as ReactComponent };